import Vue from 'vue'
import { PiniaVuePlugin, createPinia } from 'pinia'
import VueRouter from 'vue-router'
import { HeadVuePlugin, createHead } from '@vueuse/head'
import 'uno.css'
import '@/libs/flexible'

import PortalVue from 'portal-vue'
import Clarity from '@microsoft/clarity'
import { STORAGE_DEBUG } from './constants'
import errorCatch from '@/plugins/errorCatch'
import router from '@/router'
import App from '@/App.vue'
import { disableAdjustFontSize } from '@/wechat'
import { environments } from '@/config/brands'
import { fetchAppConfig } from '@/composables/useAppConfig'
import i18n from '@/i18n'

// 仅 flipnovel 家族品牌引入全局 UI 皮肤样式
const brand = import.meta.env.VITE_BRAND as string
if (brand === 'flipnovel' || brand === 'storlyn' || brand === 'moonpage' || brand === 'novaris' || brand === 'novelune')
  import('@/styles/brand-flipnovel.scss')

// NovelMello 独立皮肤：不加载 brand-flipnovel.scss，只加载自己的副本
if (brand === 'novelmello')
  import('@/styles/brand-novelmello.scss')

// 调用配置获取
fetchAppConfig()

Vue.config.productionTip = false

// Pinia
const pinia = createPinia()
Vue.use(PiniaVuePlugin)

// Head
const head = createHead()
Vue.use(HeadVuePlugin)

// Router
Vue.use(VueRouter)

// Portal
Vue.use(PortalVue)

// Error Catch
Vue.use(errorCatch)

try {
  disableAdjustFontSize()
}
catch {}

if (!import.meta.env.MODE.includes('production') || window.localStorage.getItem(STORAGE_DEBUG)) {
  // 动态 import 保证生产环境不下载 vconsole chunk(约 277KB)
  import('vconsole').then(({ default: VConsole }) => {
    // eslint-disable-next-line no-new
    new VConsole()
  })
}

// 生产环境和测试环境集成 Clarity
if (import.meta.env.MODE.includes('production') || import.meta.env.MODE.includes('testing')) {
  const mode = import.meta.env.MODE as keyof typeof environments
  const clarityId = environments[mode]?.clarityId
  if (clarityId)
    Clarity.init(clarityId)
}

// 注册 serviceWorker, 为了加桌
try {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/serviceWorker.js').then(() => {}).catch((err) => {
      console.error('Service Worker 注册失败：', err)
    })
  }
}
catch (err) {
  console.error(err)
}

new Vue({
  router,
  pinia,
  i18n,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  head,
  render: h => h(App),
}).$mount('#app')
